import { Receipt } from "lucide-react";
import { useMyInvoices } from "@/api/portal";
import { INVOICE_STATUS_LABEL, InvoiceStatus, invoiceBalance } from "@/api/invoices";

const STATUS_STYLE: Record<InvoiceStatus, string> = {
  BORRADOR: "bg-gray-100 text-gray-600",
  EMITIDA: "bg-blue-100 text-blue-700",
  PARCIAL: "bg-amber-100 text-amber-700",
  PAGADA: "bg-green-100 text-green-700",
  VENCIDA: "bg-red-100 text-red-700",
  ANULADA: "bg-gray-200 text-gray-500",
};

const currency = new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 });

export default function PortalInvoicesPage() {
  const { data, isLoading } = useMyInvoices({ pageSize: 100 });
  // Excluye borradores: un cliente de portal no debe ver facturas aún no emitidas por la firma.
  const invoices = (data?.data ?? []).filter((inv) => inv.status !== "BORRADOR");

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold text-gray-900">Facturación</h1>
        <p className="text-sm text-gray-500">Facturas emitidas por la firma a su nombre.</p>
      </div>

      <div className="card overflow-hidden">
        {isLoading && <p className="p-6 text-sm text-gray-400">Cargando...</p>}
        {!isLoading && invoices.length === 0 && (
          <p className="p-10 text-center text-sm text-gray-400">No tiene facturas emitidas.</p>
        )}
        {!isLoading && invoices.length > 0 && (
          <div className="divide-y divide-gray-100">
            {invoices.map((invoice) => (
              <div key={invoice.id} className="flex items-center justify-between p-4">
                <div className="flex items-center gap-3">
                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-brand-50 text-brand-600">
                    <Receipt size={16} />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900">
                      N.° {invoice.invoiceNumber} · {currency.format(Number(invoice.total))}
                    </p>
                    <p className="text-xs text-gray-500">
                      Emitida {invoice.issueDate} · Vence {invoice.dueDate}
                      {["PARCIAL", "VENCIDA"].includes(invoice.status) && (
                        <> · Saldo {currency.format(invoiceBalance(invoice))}</>
                      )}
                    </p>
                  </div>
                </div>
                <span className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-medium ${STATUS_STYLE[invoice.status]}`}>
                  {INVOICE_STATUS_LABEL[invoice.status]}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
